import React from 'react';

const CollectionContext = React.createContext({
	collection: null,
	collections: [],
	collectionHandler: () => {},
});

export default CollectionContext
